import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { MyConsultingComponent } from 'src/app/component-modules/trip-consulting/my-consulting/my-consulting.component';
import { LocalAuthService } from 'src/app/auth/local-auth.service';

@Component({
  selector: 'app-my-consulting-wrapper',
  templateUrl: './my-consulting-wrapper.component.html',
  styleUrls: ['./my-consulting-wrapper.component.scss'],
  standalone: true,
  imports: [CommonModule, CardModule, MyConsultingComponent]
})
export class MyConsultingWrapperComponent implements OnInit {
  @Input() staffId: number = 0;

  constructor(
   
  ) {}

  ngOnInit(): void {
    
  }
} 